
<script>
import { ref } from 'vue';
/*jshint esversion: 6 */
export default {
    name: 'CurrentFiles',
    props: {
        'model': { type: [Object], default: function() { return {};} }, 
        'schema': { type: [Object], default: function() { return {};} }, 
        'schemaId': {type: Number, default: 0}, 
    }, 
    setup(props) {
        const newValues = ref([]);
        if (props.schema.automaticSort) {
            newValues.value = props.model[props.schema.model].sort();
        } else {
            newValues.value = props.model[props.schema.model];
        }
        return {
            newValues
        }
    }
};
</script>
<template lang="pug">
.vueFormFieldMain
    .fieldCurrentFile
        div(:id="schemaId")
            label(v-if="schema.label && schema.label.length > 0") {{ schema.label }}
            br
            ul
                template(v-for="item in newValues")
                    li {{ item }}
</template>